import {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';

import {Assignables} from 'nutshell-core/assignables';

import {Stack} from 'shells/layout/stack/stack';
import {TaskRow} from 'shells/row/task-row/task-row';
import {Body} from 'shells/typography/body';

import type {CoreEntityTaskFragment as Task} from 'nutshell-graphql-types';

import {useDeleteTask} from '../../../core-entity/widgets/tasks-widget/graphql/hooks/use-delete-task';
import {useMarkUnhelpfulAndDeleteTask} from '../../../core-entity/widgets/tasks-widget/graphql/hooks/use-mark-unhelpful-and-delete-task';
import {useUpdateTask} from '../../../core-entity/widgets/tasks-widget/graphql/hooks/use-update-task';
import type {TaskMutations} from '../../../core-entity/widgets/tasks-widget/types';

type Props = {
    tasks: Task[];
};

export function FollowUpTasksSection(props: Props) {
    const {tasks} = props;
    const assignables = useSelector(Assignables.getAllEnabled);
    const [error, setError] = useState<string | null | undefined>(null);

    const {updateTask} = useUpdateTask();
    const {deleteTask} = useDeleteTask();
    const {markUnhelpfulAndDeleteTask} = useMarkUnhelpfulAndDeleteTask();

    const taskMutations: TaskMutations = useMemo(
        () => ({
            onUpdateTask: (input) => updateTask(input),
            onDeleteTask: (input) => deleteTask(input),
            onMarkUnhelpfulAndDeleteTask: (input) => markUnhelpfulAndDeleteTask(input),
        }),
        [updateTask, deleteTask, markUnhelpfulAndDeleteTask]
    );

    if (tasks.length === 0) {
        return null;
    }

    return (
        <Stack spacing={4}>
            <Body size='small' isBold={true}>
                Follow-up tasks
            </Body>
            {error && (
                <Body size='small' color='error'>
                    {error}
                </Body>
            )}
            {tasks.map((task) => (
                <TaskRow
                    key={task.id}
                    task={task}
                    assignables={assignables ?? []}
                    taskMutations={taskMutations}
                    stepMutations={undefined}
                    setError={setError}
                    hideCreatorEntity={true}
                />
            ))}
        </Stack>
    );
}
